/**
 * When something happened, in the reader's own time zone, for the games list and the activity log. The server sends
 * times as ISO 8601 or as "YYYY-MM-DD HH:MM:SS".
 */
const parse = (dateTime) => new Date(dateTime.replace(' ', 'T'));
const isToday = (date) => date.toDateString() === new Date().toDateString();
const time = (date) => date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
const day = (date) => date.toLocaleDateString([], { month: 'short', day: 'numeric' });

/** The time today, the day before that: "2:14 PM", "Nov 3". */
export const shortWhen = (dateTime) => {
  const date = parse(dateTime);
  return isToday(date) ? time(date) : day(date);
};

/** Always the time, with the day when it isn't today: "2:14 PM", "Nov 3, 2:14 PM". */
export const timeWhen = (dateTime) => {
  const date = parse(dateTime);
  return isToday(date) ? time(date) : `${day(date)}, ${time(date)}`;
};
